module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container",
    attrs: {
      "data-space-between": "10"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.bigImgList), function(item, index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.smallImgList), function(item, index) {
    return _c('div', {
      staticClass: "col-50"
    }, [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('img', {
      staticClass: "lazy",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fc3f2fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/home/body/TopAdvertise.vue
// module id = 242
// module chunks = 1